import { VueReCaptcha, useReCaptcha } from "vue-recaptcha-v3";

export default defineNuxtPlugin(nuxtApp => {
  const runtimeConfig = useRuntimeConfig();
  const { vueApp } = useNuxtApp();
  const dataAll = useDataAll();

  const form = {
    init(formData) {
      const RECAPTCHA_SITE_KEY = runtimeConfig.public.RECAPTCHA_SITE_KEY;
      let recaptchaInstance = null
      // If recaptcha init
      if (formData && RECAPTCHA_SITE_KEY && RECAPTCHA_SITE_KEY != "") {
        vueApp.use(VueReCaptcha, {
          siteKey: RECAPTCHA_SITE_KEY,
          loaderOptions: {
            renderParameters: {
              hl:dataAll.getLanguage(),
            },
          },
        });
        recaptchaInstance = useReCaptcha();
      }
      return recaptchaInstance
    },
    async addRecaptchaToPostVars(recaptchaInstance, data) {
      if (recaptchaInstance) {
        await recaptchaInstance?.recaptchaLoaded();
        const tokenGoogle = await recaptchaInstance?.executeRecaptcha("submit");
        data["tokenGoogle"] = tokenGoogle;
      }
      return data;
    },
    // keep this in sync with Services/forms.abstractFromStrategy.php function validateFormFields for PHP backend
    getRules(formDetail, index) {
      const dataAll = useDataAll();
      let rules = {};
      if (formDetail.required && formDetail.required == "1") {
        Object.assign(rules, {
          required: (value) =>
            !!value || dataAll.getStatic("required", "Field is required").replace(":attribute", index),
        });
      } else {
        Object.assign(rules, { required: true || "" });
      }
      if (formDetail.minLength) {
        Object.assign(rules, {
          minLength: (value) =>
            value.length >= formDetail.minLength ||
            dataAll.getStatic("string_min", ":attribute must be a least :min characters.").replace(":attribute", index).replace(":min", formDetail.minLength),
        });
      } else {
        Object.assign(rules, { minLength: true || "" });
      }
      if (formDetail.maxlength) {
        Object.assign(rules, {
          maxlength: (value) =>
            value.length <= formDetail.maxlength ||
            dataAll.getStatic("string_max", ":attribute must be a smaller than :max characters.").replace(":attribute", index).replace(":max", formDetail.maxlength),
        });
      } else {
        Object.assign(rules, { maxlength: true || "" });
      }
      if (formDetail.email && formDetail.email == "1") {
        Object.assign(rules, {
          email: (value) =>
            /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value) ||
            dataAll.getStatic("email", ":attribute must be an valid email").replace(":Attribute", index),
        });
      } else {
        Object.assign(rules, { email: true || "" });
      }

      if (formDetail.min) {
        Object.assign(rules, {
          min: (value) =>
            value >= formDetail.min ||
            dataAll.getStatic("number_min", ":attribute must be a bigger than :min.").replace(":attribute", index).replace(":min", formDetail.min),
        });
      } else {
        Object.assign(rules, { min: true || "" });
      }
      if (formDetail.max) {
        Object.assign(rules, {
          max: (value) =>
            value <= formDetail.max ||
            dataAll.getStatic("number_max", ":attribute must be a smaller than :max.").replace(":attribute", index).replace(":max", formDetail.max),
        });
      } else {
        Object.assign(rules, { max: true || "" });
      }      

      return rules;
    }
  }
  nuxtApp.provide('form', form);
})